import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, Flame } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../config/site";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();

  return (
    <motion.div
      data-testid={`product-card-${product.slug}`}
      className="group bg-mist rounded-3xl overflow-hidden border border-transparent hover:border-lilac-light hover:shadow-[0_20px_60px_-20px_rgba(139,92,246,0.35)] transition-all duration-500 flex flex-col"
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={`/prodotto/${product.slug}`} className="relative block overflow-hidden aspect-[4/5] bg-white">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-lilac text-white text-[10px] font-bold tracking-[0.14em] uppercase px-3 py-1.5 rounded-full">
            {product.badge}
          </span>
        )}
        {product.compare_at && (
          <span className="absolute top-3 right-3 bg-amber-400 text-white text-[10px] font-bold tracking-wide uppercase px-3 py-1.5 rounded-full">
            Offerta
          </span>
        )}
      </Link>
      <div className="p-5 flex flex-col flex-1">
        {product.scalp_type && (
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] mb-1.5" style={{ color: product.accent || "#8B5CF6" }}>
            {product.scalp_type}
          </p>
        )}
        <h3 className="font-serif text-lg text-plum leading-snug">{product.name}</h3>
        <p className="text-sm text-plum/60 mt-2 leading-relaxed line-clamp-2 flex-1">{product.short}</p>
        <div className="flex items-baseline gap-2 mt-4">
          <span className="font-serif text-xl text-plum" data-testid={`price-${product.slug}`}>
            {formatPrice(product.price)}
          </span>
          {product.compare_at && (
            <span className="text-sm text-plum/40 line-through">{formatPrice(product.compare_at)}</span>
          )}
        </div>
        {typeof product.stock_left === "number" && (
          <p
            data-testid={`card-stock-${product.slug}`}
            className="mt-2.5 inline-flex items-center gap-1 self-start bg-amber-300 text-plum text-[9px] font-bold uppercase tracking-[0.12em] px-2.5 py-1 rounded-full"
          >
            <Flame className="w-3 h-3" />
            {product.stock_left > 0 ? `Ne restano solo ${product.stock_left}` : "Esaurito al momento"}
          </p>
        )}
        <div className="flex gap-2 mt-4">
          <Link
            to={`/prodotto/${product.slug}`}
            data-testid={`scopri-${product.slug}`}
            className="flex-1 text-center text-[10px] sm:text-xs font-bold uppercase tracking-[0.05em] sm:tracking-[0.12em] py-3 px-1 rounded-full border-2 border-plum/15 text-plum hover:border-lilac-dark hover:text-lilac-dark transition-colors duration-300 whitespace-nowrap"
          >
            Scopri
          </Link>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={() => add(product)}
            className="flex-[1.5] flex items-center justify-center gap-1.5 text-[10px] sm:text-xs font-bold uppercase tracking-[0.05em] sm:tracking-[0.12em] py-3 px-1 rounded-full bg-lilac text-white hover:bg-lilac-dark active:scale-95 transition-all duration-300 whitespace-nowrap"
          >
            <ShoppingBag className="w-3.5 h-3.5 hidden sm:inline" />
            Aggiungi
          </button>
        </div>
      </div>
    </motion.div>
  );
};
